import React from "react"

import Induced from './induced/item'

class InducedComponent extends React.Component {

	state = {
	}

	render() {
		if (this.props.loading) {
			return (
				<div>Loading ...</div>
			)
		} else {
			return (
				<div className="induced-accounts-container">
					{this._drawZone("charge", "charge")}
					{this._drawZone("revenue", "recette")}
					<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`} onClick={this.props.onSave}>Enregistrer</button>
				</div>
			)
		}
	}

	_drawZone = (type, label) => {
		const accounts = this.props.accounts.filter(a => (type == "charge" ? (a.account.expense && a.account.number.charAt(0) == '6') : (a.account.receipts && a.account.number.charAt(0) == '7'))).map(a => a.account)
		return (
			<div className={"induced-account induced-" + type + "-account"}>
				<div className="induced-account-header">
					<form onSubmit={this._handleSubmit.bind(this)}>
						<div className="columns is-desktop select-container">
							<div className="column">
								<p className="field is-horizontal">
									{/*
									<span className="field-label is-normal">
										<label className="label" htmlFor="">Thématique</label>
									</span>
									*/}
									<span className="field-body">
										<span className="field has-addons has-addons-right">
											<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>

												<select value={this.state[type]} onChange={this._handleOptionChange.bind(this, type)}>
													<option value="-1">Sélectionnez une {label}</option>
													{ accounts.map(a => {
															if (this.props.induceds.filter(ac => ac.induced.id == a.id).length == 0) {
																return <option value={a.id}>{a.number} - {a.label}</option>
															} else return null
													})}
												</select>

											</span>
										</span>
									</span>
								</p>
							</div>
						</div>
						<div className="columns">
							<div className="column">
								{	this.state[type] && this.state[type] !== "-1"
									? <button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`} onClick={this._handleAddAccount.bind(this, type)}>Ajouter</button>
									: null
								}
							</div>
						</div>
					</form>
				</div>
				<div className="induced-account-body">
					{ this.props.induceds.filter(a => (type == "charge" ? a.induced.expense : a.induced.receipts)).length > 0
						? <div className="induced-account-detail induced-header-list">
								<div className="account-title">
									{label}s induites
								</div>
								<div className="account-value">
									Plus
								</div>
								<div className="account-value">
									Moins
								</div>
								<div className="account-value">
									Année
								</div>
								<div className="account-actions" />
							</div>
						: null
					}
					{this.props.induceds.filter(a => (type == "charge" ? a.induced.expense : a.induced.receipts)).map(induced => (
						<Induced 
							key={"induced-" + induced.id}
							induced={induced}
							onChange={this.props.onInducedChange}
							onRemove={this.props.onInducedRemove}
						/>
					))}
				</div>
			</div>
		)
	}

	_handleOptionChange(type, e) {
		var newState = this.state
		newState[type] = e.target.value
		this.setState(newState)
	}

	_handleAddAccount(type) {
		var state = this.state
		state[type]
		this.setState(state, () => {
			this.props.onInducedCreate({
				id: "tmp_" + create_UUID(),
				induced: this.props.accounts.find(a => a.account.id == this.state[type]).account, 
				type: type, 
				gain: null, 
				loss: null, 
				year: 0
			})
		})
	}

	_handleSubmit(e) {
		e.preventDefault()
	}

}

const create_UUID = () => {
	var dt = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (dt + Math.random()*16)%16 | 0;
			dt = Math.floor(dt/16);
			return (c=='x' ? r :(r&0x3|0x8)).toString(16);
	});
	return uuid
}

export default InducedComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/induced-component.js